/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

/**
 * NileNavTabPanel styles
 */
export const styles = css`
  [hidden] {
    display: none;
  }

  :host {
    --padding: var(--nile-spacing-none, var(--ng-spacing-none));
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
    display: none;
  }

  :host([active]) {
    display: block;
  }

  .nav-tab-panel {
    display: block;
    padding: var(--padding);
  }
`;

/**
 * NileNavTabPanel styles
 */
export default [styles];
